"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cards = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _definitions = require("@ppay/definitions");
var _Receipt = require("./Receipt");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Cards = function Cards(_ref) {
  var transactions = _ref.transactions,
    statusDotColor = _ref.statusDotColor,
    CardComponent = _ref.cardComponent,
    onRowClick = _ref.onRowClick,
    showModalViewAll = _ref.showModalViewAll;
  var _React$useState = _react.default.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isOpen = _React$useState2[0],
    setOpenModal = _React$useState2[1];
  var _React$useState3 = _react.default.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    transactionToShow = _React$useState4[0],
    setTransactionToShow = _React$useState4[1];
  var TransactionCard = (0, _styledComponents.default)(CardComponent)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding: 20px;\n    &:not(:last-child) {\n      margin-bottom: 20px;\n    }\n  "])));
  return /*#__PURE__*/_react.default.createElement("div", null, transactions.map(function (t) {
    var isFiat = !!_definitions.FIAT_TICKERS.includes(t.ticker);
    return /*#__PURE__*/_react.default.createElement(TransactionCard, {
      statusDotColor: statusDotColor,
      transaction: t,
      key: t.id,
      fiat: isFiat,
      onClick: function onClick() {
        setOpenModal(true);
        setTransactionToShow(t);
      }
    });
  }), /*#__PURE__*/_react.default.createElement(_Receipt.ReceiptModal, {
    isOpen: isOpen,
    toggle: function toggle() {
      return setOpenModal(!isOpen);
    },
    transaction: transactionToShow,
    onRowClick: onRowClick,
    statusDotColor: statusDotColor,
    showViewAll: showModalViewAll
  }));
};
exports.Cards = Cards;